import { create } from 'zustand';

export interface AgentMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  affectedEntities?: string[];
  createdAt: string;
  isStreaming?: boolean;
}

export interface AgentConversation {
  id: string;
  title: string;
  created_at: string;
  modified_at?: string;
}

interface AgentChatStore {
  isOpen: boolean;
  messages: AgentMessage[];
  conversationId: string | null;
  conversations: AgentConversation[];
  isLoading: boolean;
  isSending: boolean;

  setIsOpen: (open: boolean) => void;
  toggleOpen: () => void;
  addMessage: (message: AgentMessage) => void;
  updateLastAssistantMessage: (content: string) => void;
  setConversationId: (id: string | null) => void;
  setConversations: (conversations: AgentConversation[]) => void;
  setIsLoading: (loading: boolean) => void;
  setIsSending: (sending: boolean) => void;
  clearMessages: () => void;
  startNewConversation: () => void;
}

const useAgentChatStore = create<AgentChatStore>((set) => ({
  isOpen: false,
  messages: [],
  conversationId: null,
  conversations: [],
  isLoading: false,
  isSending: false,

  setIsOpen: (open) => set({ isOpen: open }),
  toggleOpen: () => set((state) => ({ isOpen: !state.isOpen })),

  addMessage: (message) =>
    set((state) => ({
      messages: [...state.messages, message],
    })),

  updateLastAssistantMessage: (content) =>
    set((state) => {
      const messages = [...state.messages];
      const lastIdx = messages.length - 1;
      if (lastIdx >= 0 && messages[lastIdx].role === 'assistant') {
        messages[lastIdx] = {
          ...messages[lastIdx],
          content: messages[lastIdx].content + content,
        };
      }
      return { messages };
    }),

  setConversationId: (id) => set({ conversationId: id }),
  setConversations: (conversations) => set({ conversations }),
  setIsLoading: (loading) => set({ isLoading: loading }),
  setIsSending: (sending) => set({ isSending: sending }),
  clearMessages: () => set({ messages: [] }),

  startNewConversation: () =>
    set({
      conversationId: null,
      messages: [],
    }),
}));

export default useAgentChatStore;
